export default __webpack_public_path__ + "static/media/hero-dog@2x.bc90dd3e.webp";